import { useState } from "react";
import { Input } from "@chakra-ui/react";

interface Props {
  onTimeRangeChange: (startDate: Date, endDate: Date) => void;
  style?: React.CSSProperties;
}

function CustomDateSelector({ onTimeRangeChange, style }: Props) {
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [endDate, setEndDate] = useState<Date | null>(new Date());

  return (
    <div style={{ ...style, ...styles.flexRow }}>
      <div style={styles.flexColumn}>
        <label>Start Date</label>
        <Input
          type="datetime-local"
          value={startDate ? startDate.toISOString().slice(0, 16) : ""}
          onChange={(e) => {
            setStartDate(new Date(e.target.value));
            onTimeRangeChange(new Date(e.target.value), endDate!);
          }}
        />
      </div>

      <div style={styles.flexColumn}>
        <label>End Date</label>
        <Input
          type="datetime-local"
          value={endDate ? endDate.toISOString().slice(0, 16) : ""}
          onChange={(e) => {
            setEndDate(new Date(e.target.value));
            onTimeRangeChange(new Date(e.target.value), endDate!);
          }}
        />
      </div>
    </div>
  );
}

const styles: { [key: string]: React.CSSProperties } = {
  flexRow: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  },
  flexColumn: {
    display: "flex",
    flexDirection: "column",
  },
};

export default CustomDateSelector;
